<template>
  <Doughnut :data="chartData" :options="chartOptions">
  </Doughnut>
</template>
<script>
import { Doughnut } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, CategoryScale, LinearScale } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale, LinearScale)
export default {
  name: 'doughnut-chart',
  components: {
    Doughnut
  },
  props: {
    chartLabels: Array,
    dataValues: Array
  },
  data: function () {
    return {
      chartData: {
        chartLabels: this.chartLabels,
        datasets: [{
          data: this.dataValues,
          backgroundColor: ['#222051', '#554e72', '#8e859f', '#d9d6de', '#81236c', '#9c5f8b', '#bd98b2', '#e9dee6', '#0d6d80', '#458a9c', '#8eb1bd', '#636466', '#acaeb1', '#474749'],
          borderWidth: 0,
          datalabels: {
            display: false
          }
        }],
      },
      chartOptions: {
        title: {
          display: false
        },
        animation: {
          animateScale: true,
          animateRotate: true
        },
        layout: {
          padding: 30
        },
        plugins: {
          legend: {
            display: false
          },
          tooltips: {
            enabled: false,
          },
        },
        responsive: true,
        maintainAspectRatio: true
      }
    }
  },
}
</script>
